/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Heinrich_Von_Gagern_Gymnasium3Inputs */

const en__field_enum_heinrich_von_gagern_gymnasium3 = /** @type {(inputs: _Field_Enum_Heinrich_Von_Gagern_Gymnasium3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt`)
};

const de__field_enum_heinrich_von_gagern_gymnasium3 = /** @type {(inputs: _Field_Enum_Heinrich_Von_Gagern_Gymnasium3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heinrich-von-Gagern-Gymnasium`)
};

/**
* | output |
* | --- |
* | "Frankfurt" |
*
* @param {_Field_Enum_Heinrich_Von_Gagern_Gymnasium3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_heinrich_von_gagern_gymnasium3 = /** @type {((inputs?: _Field_Enum_Heinrich_Von_Gagern_Gymnasium3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Heinrich_Von_Gagern_Gymnasium3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_heinrich_von_gagern_gymnasium3(inputs)
	return de__field_enum_heinrich_von_gagern_gymnasium3(inputs)
});
export { _field_enum_heinrich_von_gagern_gymnasium3 as "_field_enum_Heinrich_von_Gagern_Gymnasium" }